<template>
  <div>
    <b-container>
      <b-row>
        <b-col>
          <b-form-group class="container_btn_select_course">
            <b-form-checkbox-group class="btn_select_course" buttons v-model="selected_parcours_ids" :options="parcours_selector"></b-form-checkbox-group>
          </b-form-group>
        </b-col>
        <b-col md="3">
          <b-button v-b-modal.modal-coureurs-carte class="button_select_display_mode">Sélection des coureurs à suivre</b-button>
        </b-col>
      </b-row>
    </b-container>

    <SuiviMapMultiParcours
      v-if="list_lines.length > 0 && selected_parcours.length > 0"
      :coureurs="coureurs"
      :list_lines="list_lines"
      :selected_parcours="selected_parcours"
      :focus_point="focus_point"
      :selected_mode="$store.state.map_settings.selected_mode"
    ></SuiviMapMultiParcours>
    <div v-for="(parcours, index_parcours) in selected_parcours" :key="index_parcours">
      <div class="sep"></div>
      <SuiviProfilMultiParcours v-if="list_lines.length > 0 && parcours.id" :all_coureurs="coureurs" :list_lines="list_lines" :parcours="parcours"></SuiviProfilMultiParcours>
    </div>
    <div class="sep"></div>
    <div class="sep"></div>
    <h2>Statistiques de passage</h2>
    <b-container id="passages_pc_course" v-if="passages.list_parcours">
      <b-row>
        <b-col md="12">
          <div>
            <b-tabs content-class="mt-3">
              <b-tab title="Affichage par parcours" active>
                <p>Au départ d'une course, les partants passeront en coureurs attendus. Une ligne verte indique que tous les coureurs attendus ont atteint le point de passage, une ligne rouge indique que des coureurs sont encore attendus</p>
                <div v-for="(parcours, index) in passages.list_parcours.list" :key="index">
                  <SecuriteParcours :parcours="parcours"></SecuriteParcours>
                </div>
              </b-tab>
              <b-tab title="Affichage par point">
                <p>
                  Au départ d'une course, les statistiques de coureurs pour chacun des points du parcours seront répercutées sur le point associé. Une ligne verte indique que tous les coureurs attendus sont passés par la box, une ligne rouge indique
                  que des coureurs sont encore attendus
                </p>

                <div v-for="(box, index_box) in passages.list_box" :key="index_box">
                  <SecuriteBox :box="box" :name="index_box"></SecuriteBox>
                </div>
              </b-tab>
            </b-tabs>
          </div>
        </b-col>
      </b-row>
    </b-container>

    <b-modal id="modal-coureurs-carte" scrollable hide-footer title="Sélection des coureurs à suivre">
      <template #modal-header="{ close }">
        <h5>Sélection des coureurs</h5>
        <b-button size="sm" class="button_select_display_mode" @click="close()"><b-icon icon="check"></b-icon> Enregistrer et fermer</b-button>
      </template>
      <b-button class="button_select_display_mode" disabled v-bind:class="[display_mode.favorites === '1' ? 'is_selected_mode' : '']" @click="displayFavorites()">Afficher mes favoris</b-button>
      <b-button class="button_select_display_mode" v-bind:class="[display_mode.balises === '1' ? 'is_selected_mode' : '']" @click="displayBalises()">Afficher les balises</b-button>
      <b-button class="button_select_display_mode" v-bind:class="[display_mode.front_race === '1' ? 'is_selected_mode' : '']" @click="displayFrontRace()">Afficher la tête de course</b-button>
      <b-button class="button_select_display_mode" v-bind:class="[display_mode.peloton === '1' ? 'is_selected_mode' : '']" @click="displayPeloton()">Afficher le peloton</b-button>

      <div v-if="selected_list_coureurs.length > 0">
        <p><b>Coureurs suivis</b></p>
        <div class="container_list_coureur_select_cart">
          <div class="list_coureur_select_carte" v-for="(coureur, index_sel) in selected_list_coureurs" :key="index_sel">
            <div>
              <p>
                [{{ coureur.dossard }}] {{ coureur.nom }} {{ coureur.prenom }}<br />
                <span style="font-size: 0.6rem">{{ coureur.course }}</span>
              </p>
            </div>
            <div>
              <b-button size="sm" @click="removeFromSelected(index_sel)">x</b-button>
            </div>
          </div>
        </div>
      </div>

      <p><b>Suivre d'autres coureurs ?</b></p>
      <b-form-input v-model="filter_search_list_coureur" placeholder="Rechercher un coureur"></b-form-input>
      <div class="container_list_coureur_select_cart">
        <div class="list_coureur_select_carte" v-for="(coureur, index_avail) in filtered_list_coureurs_parcours" :key="index_avail">
          <div>
            <p>
              [{{ coureur.dossard }}] {{ coureur.nom }} {{ coureur.prenom }}<br />
              <span style="font-size: 0.6rem">{{ coureur.course }}</span>
            </p>
          </div>
          <div>
            <b-button size="sm" @click="addToSelected(index_avail)">+</b-button>
          </div>
        </div>
      </div>
    </b-modal>
  </div>
</template>

<script>
import SuiviMapMultiParcours from "@/components/Live_tab/PCCourse/MapLive.vue";
import SuiviProfilMultiParcours from "@/components/Live_tab/PCCourse/ProfilLive.vue";
import SecuriteParcours from "@/components/Live_tab/PCCourse/SecuriteParcours.vue";
import SecuriteBox from "@/components/Live_tab/PCCourse/SecuriteBox.vue";
import toGeoJSON from "@mapbox/togeojson/togeojson.js";
import axios from "axios";

export default {
  components: { SuiviMapMultiParcours, SuiviProfilMultiParcours, SecuriteParcours, SecuriteBox },
  data() {
    return {
      list_parcours: [],
      parcours_selector: [],
      selected_parcours_ids: [],

      list_lines: [],

      display_mode: {
        front_race: "0",
        balises: "1",
        favorites: "1",
        peloton: "0",
      },
      favoris: [],
      selected_list_coureurs: [],
      list_coureurs_parcours: [],
      coureurs: [],

      focus_point: 0,
      updateIn: 90,
      filter_search_list_coureur: "",

      passages: {},
    };
  },
  watch: {
    selected_parcours_ids() {
      this.loadGeoJSONList();
      this.fetchListCoureurs();
      this.getTrackedCoureurs();
    },
  },
  computed: {
    selected_parcours() {
      let filtered = this.list_parcours;
      filtered = filtered.filter((item) => this.selected_parcours_ids.includes(item.id));
      return filtered;
    },

    filtered_list_coureurs_parcours() {
      let filtered = this.list_coureurs_parcours;
      if (this.filter_search_list_coureur === "") {
        return filtered;
      }
      filtered = filtered.filter((item) => item.nom.toUpperCase().includes(this.filter_search_list_coureur.toUpperCase()) || item.prenom.includes(this.filter_search_list_coureur) || item.dossard.includes(this.filter_search_list_coureur));
      return filtered;
    },
    extra_coureurs_to_follow() {
      let extras = [];
      for (let i = 0; i < this.favoris.length; i++) {
        extras.push(this.favoris[i]);
      }
      for (var j = 0; j < this.selected_list_coureurs.length; j++) {
        extras.push(this.selected_list_coureurs[j].id);
      }
      return extras;
    },
  },
  methods: {
    addToSelected(index) {
      let correct_index = -1;
      for (let i = 0; i < this.list_coureurs_parcours.length; i++) {
        if (this.list_coureurs_parcours[i].id === this.filtered_list_coureurs_parcours[index].id) {
          correct_index = i;
          break;
        }
      }
      if (correct_index >= 0) {
        this.selected_list_coureurs.push(this.list_coureurs_parcours[correct_index]);
        this.list_coureurs_parcours.splice(correct_index, 1);
        this.selected_list_coureurs.sort((a, b) => (a.nom > b.nom ? 1 : -1));
        this.getTrackedCoureurs();
      }
    },
    removeFromSelected(index) {
      this.list_coureurs_parcours.push(this.selected_list_coureurs[index]);
      this.selected_list_coureurs.splice(index, 1);
      this.list_coureurs_parcours.sort((a, b) => (a.nom > b.nom ? 1 : -1));
      this.getTrackedCoureurs();
    },
    displayFrontRace() {
      if (this.display_mode.front_race === "1") {
        this.display_mode.front_race = "0";
      } else {
        this.display_mode.front_race = "1";
      }
      this.getTrackedCoureurs();
    },
    displayPeloton() {
      if (this.display_mode.peloton === "1") {
        this.display_mode.peloton = "0";
      } else {
        this.display_mode.peloton = "1";
      }
      this.getTrackedCoureurs();
    },
    displayFavorites() {
      if (this.display_mode.favorites === "1") {
        this.display_mode.favorites = "0";
      } else {
        this.display_mode.favorites = "1";
      }
      this.getTrackedCoureurs();
    },
    displayBalises() {
      if (this.display_mode.balises === "1") {
        this.display_mode.balises = "0";
      } else {
        this.display_mode.balises = "1";
      }
      this.getTrackedCoureurs();
    },
    setFocusPoint(p) {
      this.focus_point = p;
    },

    loadPassages() {
      var _this = this;
      axios.get(this.$store.state.base_url + "/pc_course/passages/get.php?id=" + this.$store.state.module.id).then(function (response) {
        console.log("LIVE -- Fetch statistiques passages");
        _this.passages = response.data;
      });
    },

    //Charge la liste des coureurs disponibles sur les courses sélectionnées
    fetchListCoureurs() {
      var _this = this;
      let data = {
        courses: this.selected_parcours,
      };
      axios.post(this.$store.state.base_url + "/pc_course/carte/list_coureurs/get.php", data).then(function (response) {
        _this.list_coureurs_parcours = response.data;
      });
    },

    // Récupere la liste des parcours associé au module
    fetchParcours() {
      var _this = this;
      axios
        .get("https://sportips.fr/api/v1/public_app/routes/get.php?id_module=" + this.$store.state.module.id)
        .then(function (response) {
          _this.buildParcoursSelector(response.data);
          _this.loadGeoJSONList();
          _this.fetchListCoureurs();
          _this.getTrackedCoureurs();
        })
        .catch(function (error) {});
    },
    // Crée le selecteur de parcours
    buildParcoursSelector(data) {
      this.list_parcours = data;
      this.parcours_selector = [];
      this.selected_parcours_ids = [];
      for (let i = 0; i < data.length; i++) {
        this.parcours_selector.push({ text: data[i].nom, value: data[i].id });
        if (this.$store.state.selected_live_course && this.$store.state.selected_live_course == data[i].nom) {
          this.selected_parcours_ids.push(data[i].id);
        }
      }
      if (!this.selected_parcours_ids.includes(data[0].id)) {
        this.selected_parcours_ids.push(data[0].id);
      }
    },
    // Charge la liste des lines des parcours selectionnés
    loadGeoJSONList() {
      var _this = this;
      _this.list_lines = [];
      for (let i = 0; i < this.selected_parcours.length; i++) {
        axios.get(this.selected_parcours[i].trace).then(function (response) {
          let geojson = toGeoJSON.gpx(new DOMParser().parseFromString(response.data, "text/xml"));
          if (geojson.features.length > 0) {
            _this.list_lines.push({ parcours_id: _this.selected_parcours[i].id, lines: geojson.features[0].geometry.coordinates });
          }
        });
      }
    },

    //Charge la liste des coureurs à tracker.
    getTrackedCoureurs() {
      var _this = this;
      var data = {
        id_module: this.$store.state.module.id,
        parcours: this.selected_parcours,
        device_user: "",
        id_user: "",
        mode: this.display_mode,
        extras: this.extra_coureurs_to_follow,
      };
      axios.post(this.$store.state.base_url + "/live/carte/multi_track_list/get.php", data).then(function (response) {
        console.log("LIVE -- Fetch tracked coureurs");
        _this.coureurs = response.data;
        _this.$forceUpdate();
      });
    },

    countdownRefresh() {
      if (!this.$store.state.live_en_cours) {
        this.$store.commit("clearRefreshIntervals");
        return;
      }
      var _this = this;
      var intervalObject = setInterval(function () {
        _this.$store.commit("clearRefreshIntervals");
        _this.getTrackedCoureurs();
        _this.loadPassages();
        _this.countdownRefresh();
      }, this.$store.state.refresh_time_carte);
      this.$store.state.refreshIntervals.push(intervalObject);
    },

    // Récupere les favoris stocké dans les cookies du navigateur
    getFavorites() {
      let key = "favorites_" + this.$store.state.module.base;
      if (this.$cookies.isKey(key)) {
        let favs = this.$cookies.get(key);
        if (favs) {
          this.favoris = favs.split(",");
        }
      }
    },
  },
  created() {
    this.$store.commit("clearRefreshIntervals");
    this.getFavorites();
    this.fetchParcours();
    this.loadPassages();
    this.countdownRefresh();
  },
};
</script>

<style lang="scss" scoped>
</style>